<div class="confirm-dialog">
  <h3 [innerHTML]="text"></h3>
  <p [innerHTML]="body"></p>
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button (click)="confirm()" mat-raised-button color="warn"><span> Tak</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
    </div>
  </div>
</div>
